import Image from "next/image"

export const ThankYou = ({ onClose, onClick, title, subtitle }) => {
  return <div className="bg-[rgba(0,0,0,0.8)] fixed top-0 h-screen w-screen flex justify-center items-center p-4 z-50">
    <div className="gap-4 bg-[url(/thankyoubg.png)] bg-cover bg-no-repeat pb-20 p-6 lg:pt-20 lg:pb-[158px] w-full lg:w-[50%] flex shadow-2xl justify-center items-center rounded-3xl lg:rounded-[50px] flex-col relative">
      <div className="absolute top-10 right-10">
        <Image src="/closex.svg" alt="Close Icon" className="cursor-pointer" width={48} height={48} onClick={() => onClose(false)} />
      </div>
      <img src="/chat.svg" alt="Chat Icon" width={240} height={240} className="w-[150px] h-[150px] xl:w-[240px] xl:h-[240px]" />
      <p className="font-aileron text-[32px] xl:text-[80px] font-bold text-[#4A3697] text-center" style={{ color: "#4A3697" }}>{title ? title : "Thank you!"}</p>
      <p className="text-base lg:text-[24px] font-lato font-normal text-center lg:w-[70%]">{subtitle ? subtitle : "Your request has been successfully submitted. We will get in touch with you at the earliest."}</p>
      {typeof onClick == "function" && <button onClick={onClick} className="mt-10 bg-[#EF7B22] text-white py-2 px-6 hover:bg-[#D76F1F] rounded-md w-full md:w-[169px] h-[45px]">
        Download Report
      </button>}
    </div>
  </div>
}